import { Box, InfoTitle } from "@/common/components";
import { styled } from "@/stitches.config";

export const StyledTitle = styled('span', {
  color: '$darkBlue300',
  fontSize: '$lg',
  fontWeight: '$bold'
});

export const StyledContentContainer = styled(Box, {
  borderBottom: '$borderWidths$1 solid $colors$seafoam300',
  display: 'flex',
  gap: '$10',
  marginTop: '$6',
  paddingBottom: '$6',
});

export const StyledApptInfoContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  paddingRight: '$10'
});

export const StyledApptInfoTitle = styled(InfoTitle, { marginBottom: '$4' });

export const StyledApptInfoValue = styled(Box, {
  fontSize: '$5',
  fontWeight: '$medium',
  lineHeight: '$6',
});
